import isDriverLeaderboard from './isDriverLeaderboard';

const isWeatherBoard = (
  board: DashboardType | WeatherBoardType | DriverLeaderboardSlide,
): board is WeatherBoardType => {
  // @ts-ignore
  if (board.canvas) {
    return false;
  }
  // A driver leaderboard slide also has no canvas but is not a weather board.
  if (isDriverLeaderboard(board)) {
    return false;
  }
  return true;
};

export default isWeatherBoard;
